<template>
  <div>
    <header>
      <div class="container-fluid">
        <div class="row">
          <nav class="navbar navbar-expand-lg navbar-light p-4">
            <div class="container-fluid mx-lg-5">
              <router-link to="/">
                <img src="../assets/images/amlakplus-logo.svg" class="navbar-brand ms-lg-5 me-lg-5 ps-lg-5" alt="" />
              </router-link>
              <button class="navbar-toggler" type="button" data-bs-toggle="collapse"
                data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false"
                aria-label="Toggle navigation">
                <span class="navbar-toggler-icon"></span>
              </button>
              <div class="collapse navbar-collapse ms-3 ms-lg-0" id="navbarSupportedContent">
                <ul class="navbar-nav me-auto mb-2 mb-lg-0 w-100">
                  <!-- <li class="nav-item me-lg-5">
                                        <router-link class="nav-link" aria-current="page" to="">خرید</router-link>
                                    </li>
                                    <li class="nav-item me-lg-5">
                                        <router-link class="nav-link" to="">رهن و اجاره</router-link>
                                    </li> -->
                  <li class="nav-item pe-lg-5">
                    <router-link class="nav-link" v-if="$store.state.isAuthenticated" to="/realEstate">
                      مشاورین املاک
                    </router-link>
                  </li>
                  <li class="nav-item">
                    <router-link to="/aboutus" class="nav-link">وبلاگ</router-link>
                  </li>
                </ul>
                <div class="container text-start text-lg-end p-0 me-lg-5 ps-lg-0 pe-lg-5">
                  <span class="navbar-text d-inline-block pt-0 mb-2 mb-lg-0 me-lg-4">
                    <router-link v-if="!$store.state.isAuthenticated" to="/Login" class="text-muted accordion-body p-0">
                      ورود
                    </router-link>
                    <span @click="dologout" v-if="$store.state.isAuthenticated" class="pointer text-muted accordion-body p-0">
                      خروج
                    </span>
                  </span>
                  <router-link to="/advertising"
                    class="btn text-light color-bg-green rounded-pill d-block d-lg-inline-block me-lg-5">
                    ثبت آگهی</router-link>
                </div>
              </div>
              <!-- <button @click="isAuthenticated = false">nope</button>
              <button @click="isAuthenticated = true">yes</button>
              <span>{{ isAuthenticated }}</span>
              {{ isAuthenticated }} -->
            </div>
          </nav>
        </div>
      </div>
    </header>
  </div>
</template>

<script>
export default {
  name: "Navbar",
  data() {
    return {
      isAuthenticated: false,
      get token() {
        return window.localStorage.getItem("token");
      },
      set token(value) {
        window.localStorage.setItem("token", value);
      },
    };
  },
  methods: {
    dologout() {
      this.$store.commit("logout");
      this.$router.push("login");
    },
    stringToBoolean(stringValue) {
      switch (stringValue?.toLowerCase()?.trim()) {
        case "true":
        case "yes":
        case "1":
          return true;

        case "false":
        case "no":
        case "0":
        case null:
        case undefined:
          return false;

        default:
          return JSON.parse(stringValue);
      }
    }
  },
  mounted() {
    // this.isAuthenticated = this.stringToBoolean(window.localStorage.getItem("isAuthenticated"));
    // console.log("navbar" + window.localStorage.getItem("isAuthenticated"));
    // console.log("navbar" + this.stringToBoolean(window.localStorage.getItem("isAuthenticated")));
  },
  watch: {
    // isAuthenticated(value) {
    //   window.localStorage.setItem("isAuthenticated", value);
    // }
  }
};
</script>
